import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "app-nav",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "container app-nav__inner" }
const _hoisted_3 = { class: "app-nav__actions" }

import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import LanguageToggleButtonC from "@/components/LanguageToggleButtonC.vue";
import { useAuthStore } from "@/store/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const authStore = useAuthStore();

const logout = () => {
  authStore.logout();
  router.push("/");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "app-nav__brand has-text-weight-bold"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Jör", -1),
            _createElementVNode("span", { class: "app-nav__brand-dot" }, ".", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(LanguageToggleButtonC),
          (_unref(authStore).loggedIn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_router_link, {
                  to: "/create-project",
                  class: "button is-small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("nav.createProject")), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  class: "button is-small is-outlined",
                  onClick: logout
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "icon" }, [
                    _createElementVNode("i", { class: "fas fa-sign-out-alt" })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.logout")), 1)
                ])
              ], 64))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/login",
                class: "button is-small is-outlined"
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "icon" }, [
                    _createElementVNode("i", { class: "fas fa-sign-in-alt" })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.login")), 1)
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})